/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import { Person } from './person.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlBuilderService } from '@irian-ro/abstract-resource';
import { Observable } from 'rxjs/index';
import { LazyLoadEvent } from 'primeng/api';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable()
export class PersonService {
  private readonly url: string = '/api/person';

  constructor(
    private readonly httpClient: HttpClient,
    @Optional() private readonly environmentService: EnvironmentService
  ) {
    if (this.environmentService && this.environmentService.getEnvironmentProperty('baseUrl')) {
      this.url = `${this.environmentService.getEnvironmentProperty('baseUrl')}/person`;
    }
  }

  getPeople(event: LazyLoadEvent): Observable<Person[]> {
    return this.httpClient.get<Person[]>(UrlBuilderService.createUrlFromLazyLoadEvent(this.url, event));
  }

  getPerson(uuid: string): Observable<Person> {
    const url = `${this.url}/${uuid}`;
    return this.httpClient.get<Person>(url);
  }

  save(person: Person): Observable<Person> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    return this.httpClient.post(this.url, JSON.stringify(person), {
      headers: headers,
    });
  }

  update(person: Person) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    return this.httpClient.put(this.url, JSON.stringify(person), {
      headers: headers,
    });
  }

  delete(uuid: string) {
    const url = `${this.url}/${uuid}`;
    this.httpClient.delete(url).subscribe({
      error: (error) => console.log(error),
    });
  }
}
